/*
 * Barras de jornada por persona del último día transcurrido del periodo (entrada, almuerzo y salida sobre
 * el día, con la línea de las 08:00). Reutiliza las jornadas de /attendance/jornadas/ que ya cargó el
 * contenedor (mismo patrón de la sección Horas: solo con status 'ok' y solo la fecha del día elegido; la
 * jornada en curso solo se extiende hasta "ahora" si el día es hoy, lo resuelve BarraJornada). Muestra hasta
 * MAX_ROWS y enlaza a Ingresos de ese día para ver todas. Estados de carga y error propios del panel.
 */
import React from "react";
import {Link, useLocation} from "react-router-dom";
import BarraJornada, {TimelineAxis} from "../../components/BarraJornada";
import EmployeeName from "../../components/EmployeeName";
import StatusBadge from "../../components/StatusBadge";
import StateView from "../../components/StateView";
import {arrivalStatus, entryList, hhmm} from "../../utils/rows";
import {shortDayLabel, writeFilters} from "../../utils/period";
import {dayForBars} from "../../utils/dashboard";

const MAX_ROWS = 12;

const DayBarsPanel = ({rows, status, message, onRetry, filters, range, today}) => {
    const location = useLocation();
    const day = dayForBars(range, today);
    if (!day) return null;
    const list = status === 'ok' ? entryList(rows.filter((row) => row.fecha === day)) : [];
    const dayLink = {pathname: location.pathname, search: writeFilters({...filters, seccion: 'ingresos', periodo: 'hoy', fecha: day})};
    return (
        <div className="mc-panel">
            <h3 className="mc-panel__title">Jornadas del {day === today ? 'día de hoy' : shortDayLabel(day)}</h3>
            <StateView status={status} message={message} onRetry={onRetry} isEmpty={list.length === 0}
                       emptyTitle="Nadie marcó entrada ese día"
                       emptyHint="Prueba con otro periodo o quita los filtros de zona, tienda o empleado.">
                <div className="mc-list__head" aria-hidden="true">
                    <span>Persona</span><span>Entrada</span><span>Llegada</span><TimelineAxis/>
                </div>
                <ul className="mc-list">
                    {list.slice(0, MAX_ROWS).map((row) => {
                        const arrival = arrivalStatus(row);
                        return (
                            <li key={`${row.fecha}-${row.id_empleado}`} className="mc-list__item mc-list__item--timeline">
                                <EmployeeName row={row}/>
                                <span className="mc-list__time mc-num">{hhmm(row.entrada)}</span>
                                <StatusBadge tone={arrival.tone} text={arrival.text}/>
                                <BarraJornada row={row} today={today}/>
                            </li>
                        );
                    })}
                </ul>
                {list.length > MAX_ROWS &&
                    <Link className="btn btn-link btn-sm mc-clear" to={dayLink}>Ver las {list.length} jornadas en Ingresos</Link>}
            </StateView>
        </div>
    );
};

export default DayBarsPanel;
